export const CLEAN_VIDEO_SUBTITLE_LANGUAGE_ID = "clean-video-id";

export const isCleanVideoSubtitleLanguageId = (id: string): boolean => id === CLEAN_VIDEO_SUBTITLE_LANGUAGE_ID;
